global.axios = require('axios');
global.$ = global.jQuery = require('jquery');

require('./scripts');
require('./shared');
require('./cookie');
